import { loadSetting, saveSetting, loadAussteller, type AusstellerSettings } from './settingsService';
import type { Rechnung, Aussteller } from '../modules/abrechnung/types';

const KEY = 'rechnungen_v1';

export async function loadRechnungen(): Promise<Rechnung[]> {
  return loadSetting<Rechnung[]>(KEY, []);
}

export async function saveRechnung(r: Rechnung): Promise<void> {
  const all = await loadRechnungen();
  const idx = all.findIndex(x => x.rechnungsNr === r.rechnungsNr);
  if (idx >= 0) {
    all[idx] = r;
  } else {
    all.push(r);
  }
  await saveSetting(KEY, all);
}

export async function updateRechnungsStatus(
  nr: string,
  status: Rechnung['status'],
): Promise<void> {
  const all = await loadRechnungen();
  const r = all.find(x => x.rechnungsNr === nr);
  if (r !== undefined) {
    r.status = status;
    await saveSetting(KEY, all);
  }
}

export async function nextLaufNr(mandantKurz: string): Promise<number> {
  const all = await loadRechnungen();
  const year = new Date().getFullYear();
  const prefix = `${year}-${mandantKurz}-`;
  const used = all
    .filter(r => r.rechnungsNr.startsWith(prefix))
    .map(r => parseInt(r.rechnungsNr.slice(prefix.length), 10))
    .filter(n => !isNaN(n));
  return used.length === 0 ? 1 : Math.max(...used) + 1;
}

// Laedt Aussteller aus DB und konvertiert zu abrechnung/Aussteller
export async function loadAusstellerForRechnung(): Promise<Aussteller> {
  const s: AusstellerSettings = await loadAussteller();
  return {
    name:      s.name,
    titelVor:  s.titelVor  !== '' ? s.titelVor  : undefined,
    titelNach: s.titelNach !== '' ? s.titelNach : undefined,
    strasse:   s.strasse,
    plz:       s.plz,
    ort:       s.ort,
    land:      s.land,
    uid:       s.uid,
    iban:      s.iban,
    bic:       s.bic,
    bank:      '',
    telefon:   s.telefon !== '' ? s.telefon : undefined,
    email:     s.email   !== '' ? s.email   : undefined,
  };
}
